var _desc, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "580px",
    height: "580px",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 5800 5800",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "delete icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "delete icon from the IconExperience.com I-Collection. Copyright by INCORS GmbH (www.incors.com).")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m807.25 1362.7 608.23-608.23 1490.6 1506.6 1531.9-1551 608.23 608.23-1501.2 1557.2 1537.1 1545.8-608.23 608.23-1543.3-1564.2-1551.2 1519.7-608.23-608.23 1520.4-1525.9z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 260
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete3);
export default __webpack_public_path__ + "static/media/delete3.6cf9f5e572bf1bbae80876e5596b7384.svg";
export { ForwardRef as ReactComponent };